var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationConversation = function SvgNotificationConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m5.25 12.25 2.917-2.346M5.25 9.917v2.333M5.25 9.917h-.583A2.917 2.917 0 0 1 1.75 7V4.667A2.917 2.917 0 0 1 4.667 1.75h4.666a2.917 2.917 0 0 1 2.917 2.917V7a2.917 2.917 0 0 1-2.917 2.917H8.167"
  })));
};
export { SvgNotificationConversation as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmU2MDdlZTlmODZmYTcyMmVmOTQ1MTVmMmMyMTI2YTYuc3ZnIjs=";